import { create } from 'zustand'

export type DialogTone = 'default' | 'destructive' | 'warning' | 'success' | 'info'
export type DialogKind = 'confirm' | 'alert' | 'prompt'
export type DialogValue = boolean | string | null | undefined

export interface ConfirmOpts {
  title?: string; message?: string; tone?: DialogTone; confirmLabel?: string; cancelLabel?: string
}
export interface AlertOpts {
  title?: string; message?: string; tone?: DialogTone; confirmLabel?: string
}
export interface PromptOpts {
  title?: string; message?: string; tone?: DialogTone; confirmLabel?: string; cancelLabel?: string
  defaultValue?: string; placeholder?: string; inputType?: 'text' | 'password' | 'email' | 'url'; required?: boolean
}

/** Fully-resolved shape the host renders. */
export interface NormalizedDialog {
  title?: string
  message?: string
  tone: DialogTone
  confirmLabel: string
  cancelLabel: string
  isPrompt: boolean
  defaultValue: string
  placeholder?: string
  inputType: 'text' | 'password' | 'email' | 'url'
  required: boolean
  hasCancel: boolean
}

export interface DialogRequest {
  id: number
  kind: DialogKind
  options: NormalizedDialog
  resolve: (value: DialogValue) => void
}

interface DialogState {
  queue: DialogRequest[]
  enqueue: (req: Omit<DialogRequest, 'id'>) => void
  resolveTop: (value: DialogValue) => void
}

let nextId = 1

/** Test-only: reset the id counter so ids are deterministic per test file. */
export const _resetDialogIds = () => { nextId = 1 }

export const useDialogStore = create<DialogState>((set, get) => ({
  queue: [],
  enqueue: (req) => set((s) => ({ queue: [...s.queue, { ...req, id: nextId++ }] })),
  resolveTop: (value) => {
    const top = get().queue[0]
    if (!top) return
    top.resolve(value)
    set((s) => ({ queue: s.queue.slice(1) }))
  },
}))
